import axios from 'axios'

// Uploads the given file of the given type to the given URL.
const upload = ({ url, type, file }) => {
    const reader = new FileReader()
    return new Promise((resolve, reject) => {
        reader.onerror = () => {
            reader.abort()
            reject(new Error('OOPS'))
        }
        reader.onload = () => {
            resolve(reader.result)
        }
        reader.readAsArrayBuffer(file)
    }).then((data) => {
        return axios.put(url, data, {
            headers: {
                'Content-Type': type
            }
        })
    })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Failed to upload.', error)
            throw new Error('OOPS')
        })
}

export {
    upload
}



// WEBPACK FOOTER //
// ./src/helpers/uploads.js